import axios from "axios";

// Use a same-origin API base in production (Emergent ingress routes /api/* to the
// backend container). This avoids cross-site cookie issues between
// frontend (e.g. lalutrive.ch) and backend (e.g. lutrive-pharmacy.emergent.host).
// REACT_APP_BACKEND_URL is still honored when explicitly set to the same origin
// or in development (CRA on a different port via proxy).
const RAW_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const FRONTEND_ORIGIN = typeof window !== "undefined" ? window.location.origin : "";

function resolveBackendBase() {
    if (!RAW_BACKEND_URL) return FRONTEND_ORIGIN;
    try {
        const u = new URL(RAW_BACKEND_URL);
        // If REACT_APP_BACKEND_URL is set to the same origin as the page, use relative.
        if (FRONTEND_ORIGIN && u.origin === FRONTEND_ORIGIN) return "";
        // Otherwise, in the browser, always prefer same-origin to keep cookies first-party.
        if (FRONTEND_ORIGIN) return FRONTEND_ORIGIN;
        return RAW_BACKEND_URL.replace(/\/+$/, "");
    } catch {
        return FRONTEND_ORIGIN;
    }
}

const BACKEND_URL = resolveBackendBase();

export const api = axios.create({
    baseURL: `${BACKEND_URL}/api`,
    withCredentials: true,
});

export const API_BASE = `${BACKEND_URL}/api`;

// Helper: get current admin (or null)
export async function fetchMe() {
    try {
        const r = await api.get("/auth/me");
        return r.data;
    } catch (err) {
        if (err?.response?.status && err.response.status !== 401) {
            console.warn("fetchMe failed", err.response.status);
        }
        return null;
    }
}

export async function logout() {
    try {
        await api.post("/auth/logout");
    } catch (err) {
        console.warn("logout failed", err?.message);
    }
}

export const loginUrl = `${API_BASE}/auth/infomaniak/login`;
